// Redux
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import * as actions from '../store/actions'
import Discount from '../components/cart-discounts'

const mapStateToProps = ({ cart }) => {
  return {
    checkDiscountCodeRetrieving: cart.checkDiscountCodeRetrieving,
    checkDiscountCodeResponse: cart.checkDiscountCodeResponse,
    checkDiscountCodeError: cart.checkDiscountCodeError
  }
}

const mapDispatch = (dispatch) => {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatch)(Discount)
